import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./../notificationSlice";
import { factory } from "../../../api/apiFactory";
const jCategoryApi = factory.get("jCategory");
const initialState = {
  searchBody: {
    name: "",
  },
  JCategory: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      name: "",
      logo: "",
      sequence: "",
      _method: "PUT",
    },
  },
  JCategories: {
    loading: false,
    data: [],
    total: 0,
  },
  JCategoriesList: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const jCategorySlice = createSlice({
  name: "JCategories",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.JCategory.dialog = !state.JCategory.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.JCategories.data = payload.data.data;
      state.JCategories.total = payload.data.total;
    },
    setDatalist: (state, { payload }) => {
      state.JCategoriesList.data = payload.data.data;
      state.JCategoriesList.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.JCategory.form = payload;
    },
    setLoading: (state, action) => {
      state.JCategories.loading = !state.JCategories.loading;
    },
    resetForm: (state, action) => {
      state.JCategory.form = initialState.JCategory.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
  setDatalist,
} = jCategorySlice.actions;

export default jCategorySlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("jCategory"));
    const res = await jCategoryApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("jCategory"));
  } catch (err) {
    dispatch(setLoading("jCategory"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getAllList = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("jCategory"));
    const res = await jCategoryApi.getAllList(params);
    dispatch(setDatalist(res));
    dispatch(setLoading("jCategory"));
  } catch (err) {
    dispatch(setLoading("jCategory"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await jCategoryApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("jCategory"));
    const res = await jCategoryApi.getById(id);
    dispatch(setById(res.data.data[0]));

    dispatch(setDialog());
    dispatch(setLoading("jCategory"));
  } catch (err) {
    dispatch(setLoading("jCategory"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data, _SearchBody) => async (dispatch) => {
  try {
    await jCategoryApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة  بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog(_SearchBody));
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await jCategoryApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم التعديل  بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const toggleShown = (data, _SearchBody) => async (dispatch) => {
  try {
    await jCategoryApi.toggleShown(data);
    dispatch(
      showNotification({
        message: "تم التعديل  بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const JCategories = {
  getAll,
  deleteById,
  getById,
  create,
  update,
  getAllList,
  toggleShown,
};
